import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=51480afe&scoped=true&"
import script from "./GamesList.vue?vue&type=script&lang=js&"
export * from "./GamesList.vue?vue&type=script&lang=js&"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=51480afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51480afe",
  null
  
)

export default component.exports